// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/contracts/attribution_policy.yaml
// Regenerate: uv run python execution/generate_attribution_policy.py

export const ATTRIBUTION_POLICY_VERSION = 1 as const;
export type LandingCluster =
  | "home"
  | "embed"
  | "product"
  | "matching"
  | "kundli"
  | "dosha"
  | "panchang"
  | "muhurat"
  | "rashifal"
  | "festival"
  | "other"
  | "_unattributed";
export type AcquisitionChannel =
  | "Widget Embed"
  | "Paid Search"
  | "Share"
  | "AI Assistant"
  | "Organic Search"
  | "Organic Social"
  | "Direct"
  | "Referral";

// Policy projection; keep byte-stable with the generator check.
// prettier-ignore
const LOCALE_PREFIXES = [
  "hi"
] as const;
// prettier-ignore
const LANDING_CLUSTERS = [
  {
    "id": "embed",
    "patterns": [
      "^/embed/"
    ]
  },
  {
    "id": "product",
    "patterns": [
      "^/products?/"
    ]
  },
  {
    "id": "matching",
    "patterns": [
      "^/(kundli-matching|gun-milan)"
    ]
  },
  {
    "id": "kundli",
    "patterns": [
      "^/(free-)?kundali",
      "^/(free-)?kundli",
      "^/janam-kundali"
    ]
  },
  {
    "id": "dosha",
    "patterns": [
      "^/(dosha|dosh)",
      "kaal-sarp",
      "mangal-dosh",
      "pitra-dosh",
      "sade-sati"
    ]
  },
  {
    "id": "panchang",
    "patterns": [
      "^/panchang",
      "^/tithi-",
      "^/nakshatra-",
      "^/yoga-",
      "^/karana-"
    ]
  },
  {
    "id": "muhurat",
    "patterns": [
      "^/muhurat",
      "^/shubh-muhurat",
      "^/rahu-kaal",
      "^/choghadiya"
    ]
  },
  {
    "id": "rashifal",
    "patterns": [
      "^/rashifal",
      "^/(daily-)?horoscope",
      "^/aaj-ka-rashifal",
      "-daily-horoscope"
    ]
  },
  {
    "id": "festival",
    "patterns": [
      "-(20[0-9]{2})$"
    ]
  }
] as const;
// prettier-ignore
const HOME_PATHS: ReadonlySet<string> = new Set([
  "/"
]);
// prettier-ignore
const UNKNOWN_PATHS: ReadonlySet<string> = new Set([
  "unknown"
]);
// prettier-ignore
const CHANNELS = [
  {
    "id": "Widget Embed",
    "locationPatterns": [
      "://[^/]+/embed/"
    ],
    "referrerPatterns": [],
    "emptyReferrer": false
  },
  {
    "id": "Paid Search",
    "locationPatterns": [
      "[?&](gclid|gbraid|wbraid)=",
      "[?&]utm_medium=(cpc|ppc|paid|paidsearch|paid_search)"
    ],
    "referrerPatterns": [],
    "emptyReferrer": false
  },
  {
    "id": "Share",
    "locationPatterns": [
      "[?&]utm_source=share(&|#|$)"
    ],
    "referrerPatterns": [],
    "emptyReferrer": false
  },
  {
    "id": "AI Assistant",
    "locationPatterns": [],
    "referrerPatterns": [
      "(chatgpt\\.com|chat\\.openai\\.com|gemini\\.google|bard\\.google|perplexity\\.ai|claude\\.ai|copilot\\.microsoft|\\.bing\\.com/chat|duck\\.ai|qwen\\.ai|yuanbao\\.tencent\\.com)"
    ],
    "emptyReferrer": false
  },
  {
    "id": "Organic Search",
    "locationPatterns": [],
    "referrerPatterns": [
      "(google\\.[a-z.]+/|google\\.[a-z.]+$|www\\.google|search\\.brave|\\.bing\\.com|bing\\.com/|search\\.yahoo|\\.search\\.yahoo|duckduckgo\\.com|ecosia\\.org|yandex\\.|baidu\\.com|naver\\.com|search\\.google|rediff\\.com|qwant\\.com|startpage\\.|petalsearch\\.com|nortonsafesearch\\.com|panda-search\\.org|seznam\\.cz|privacywall\\.org|mojeek\\.com)"
    ],
    "emptyReferrer": false
  },
  {
    "id": "Organic Social",
    "locationPatterns": [],
    "referrerPatterns": [
      "(facebook\\.com|fb\\.com|l\\.facebook|m\\.facebook|instagram\\.com|l\\.instagram|youtube\\.com|youtu\\.be|twitter\\.com|x\\.com|t\\.co/|linkedin\\.com|lnkd\\.in|pinterest\\.|whatsapp|reddit\\.com|t\\.me/|telegram|quora\\.com|threads\\.net|tiktok\\.com|snapchat\\.com|l\\.wl\\.co)"
    ],
    "emptyReferrer": false
  },
  {
    "id": "Direct",
    "locationPatterns": [],
    "referrerPatterns": [
      "(ishvaram\\.com|\\.run\\.app|localhost|^https?://(10|127|192\\.168)\\.|jyotish-api)"
    ],
    "emptyReferrer": true
  }
] as const;
// prettier-ignore
const GOVERNED_LANDING_CLUSTERS: ReadonlySet<string> = new Set([
  "home",
  "embed",
  "product",
  "matching",
  "kundli",
  "dosha",
  "panchang",
  "muhurat",
  "rashifal",
  "festival",
  "other",
  "_unattributed"
]);
// prettier-ignore
const GOVERNED_ACQUISITION_CHANNELS: ReadonlySet<string> = new Set([
  "Widget Embed",
  "Paid Search",
  "Share",
  "AI Assistant",
  "Organic Search",
  "Organic Social",
  "Direct",
  "Referral"
]);

export function isGovernedLandingCluster(value: unknown): value is LandingCluster {
  return typeof value === "string" && GOVERNED_LANDING_CLUSTERS.has(value);
}

export function isGovernedAcquisitionChannel(value: unknown): value is AcquisitionChannel {
  return typeof value === "string" && GOVERNED_ACQUISITION_CHANNELS.has(value);
}

function normalizedPolicyPath(value: string): string {
  const raw = (value || "/").split("?")[0].split("#")[0] || "/";
  const path = (raw.startsWith("/") ? raw : `/${raw}`).replace(/\/{2,}/g, "/");
  const trimmed = path.length > 1 ? path.replace(/\/+$/, "") : path;
  for (const locale of LOCALE_PREFIXES) {
    if (trimmed === `/${locale}`) return "/";
    if (trimmed.startsWith(`/${locale}/`)) return trimmed.slice(locale.length + 1) || "/";
  }
  return trimmed;
}

export function classifyLandingPath(value: string): LandingCluster {
  const path = normalizedPolicyPath(value);
  if (UNKNOWN_PATHS.has(path) || UNKNOWN_PATHS.has(value)) {
    return "_unattributed";
  }
  if (HOME_PATHS.has(path)) return "home";
  for (const rule of LANDING_CLUSTERS) {
    if (rule.patterns.some((pattern) => new RegExp(pattern, "i").test(path))) return rule.id;
  }
  return "other";
}

export function classifyAcquisitionChannel(referrer: string, location: string): AcquisitionChannel {
  const ref = (referrer || "").toLowerCase();
  const loc = (location || "").toLowerCase();
  for (const rule of CHANNELS) {
    if (rule.emptyReferrer && !ref.trim()) return rule.id;
    if (rule.locationPatterns.some((pattern) => new RegExp(pattern, "i").test(loc))) {
      return rule.id;
    }
    if (rule.referrerPatterns.some((pattern) => new RegExp(pattern, "i").test(ref))) {
      return rule.id;
    }
  }
  return "Referral";
}
